import { Close, Download } from "@mui/icons-material";
import { CircularProgress, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FILE_BASE_URL } from "constants";
import { convertUrlToFileName, getFileType } from "helper/data-converter";
import useDownloader from "react-use-downloader";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        color={props.is_reciver ? "secondary" : "primary"}
        value={props.isDownloading ? props.progress : 0}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999999,
        }}
      >
        {!props.isDownloading ? (
          <IconButton
            color={props.is_reciver ? "secondary" : "primary"}
            onClick={(e) => {
              e.stopPropagation();
              props.download();
            }}
          >
            <Download />
          </IconButton>
        ) : (
          <IconButton
            color={props.is_reciver ? "secondary" : "primary"}
            onClick={(e) => {
              e.stopPropagation();
              props.cancel();
            }}
          >
            <Close />
          </IconButton>
        )}
      </Box>
    </Box>
  );
}

export default function ProgressiveBtn({ is_reciver, file }) {
  const { size, percentage, download, cancel, isInProgress } = useDownloader();

  const fileName = convertUrlToFileName(file);

  const getFileDownloadProgressSize = () => {
    const fileSize = Math.round(size / 1024 / 1000);
    return fileSize + "/" + (percentage * fileSize) / 100;
  };

  return (
    <>
      <Typography
        sx={{ width: "100%", marginRight: 2 }}
        noWrap
        className="title"
      >
        {getFileType(fileName, true)}
      </Typography>
      {isInProgress ? getFileDownloadProgressSize() + "MB" : null}
      <CircularProgressWithLabel
        progress={percentage ?? null}
        isDownloading={isInProgress}
        is_reciver={is_reciver}
        download={() => download(FILE_BASE_URL + file, fileName)}
        cancel={() => {
          cancel();
        }}
      />
    </>
  );
}
